import { render, staticRenderFns } from "./ContactsChange.vue?vue&type=template&id=23d84be4&scoped=true&"
import script from "./ContactsChange.vue?vue&type=script&lang=js&"
export * from "./ContactsChange.vue?vue&type=script&lang=js&"
import style0 from "./ContactsChange.vue?vue&type=style&index=0&id=23d84be4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d84be4",
  null
  
)

export default component.exports